import { Grid, Typography } from '@mui/material';
import { ICompanyProductViewModel } from 'Interfaces/ICompanyProductConfig';
import React from 'react';

type EditCompanyProductFormProps = {
  companyProduct: ICompanyProductViewModel;
  handleSave: (editedCompanyProduct: ICompanyProductViewModel) => void;
};

const EditCompanyProductForm: React.FC<EditCompanyProductFormProps> = ({
  companyProduct,
  handleSave,
}) => {
  const [selectedCompanyProduct, setSelectedCompanyProduct] =
    React.useState<ICompanyProductViewModel>(companyProduct);

  const handleChange = (
    field: keyof ICompanyProductViewModel,
    value: string | number
  ) => {
    const updated = { ...selectedCompanyProduct, [field]: value };
    setSelectedCompanyProduct(updated);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSave(selectedCompanyProduct);
  };

  return (
    <Grid
      container
      component='form'
      onSubmit={handleSubmit}
      spacing={2}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'primary.main',
        padding: 2,
      }}
    >
      {/* HEADER */}
      <Grid item xs={12}>
        <Typography
          variant='h6'
          color='primary.contrastText'
          sx={{ fontWeight: 'bold', textAlign: 'center' }}
        >
          Edit Company Product
        </Typography>
      </Grid>
      {/* EDIT PICTURE */}
      <Grid item xs={12}>
        {/*    // Placeholder for image upload component
               // with open file dialog */}
      </Grid>
    </Grid>
  );
};

export default EditCompanyProductForm;
